import moment from 'moment'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import { i18nDateToString } from 'modules/core/lib/dates'

import { useAddUnassignedShifts } from 'modules/shift_management/hooks/useAddUnassignedShifts'
import UnassignedShiftForm from 'modules/shift_management/lib/forms/UnassignedShiftForm'

interface Props {
  date: moment.Moment
}

const useUnassignedCustomShiftForm = ({ date }: Props) => {
  const {
    company: { id: currentCompanyId },
  } = useCurrentSession()
  const unassignedShiftForm = useLazyRef<UnassignedShiftForm>(
    () =>
      new UnassignedShiftForm({
        start_date: i18nDateToString(date, 'backend'),
        end_date: i18nDateToString(date, 'backend'),
        staff_requirements: [
          { job_catalog_roles_ids: [], job_catalog_tree_role_uuids: [], staff_count: 1 },
        ],
      })
  ).current

  const useSubmitUnassignedCustomShift = () => {
    const { onSubmit, submitting } = useAddUnassignedShifts({
      form: unassignedShiftForm,
      companyId: currentCompanyId,
      startDate: moment(unassignedShiftForm.get('start_date').value),
      endDate: moment(unassignedShiftForm.get('end_date').value),
    })

    return {
      onSubmit,
      submitting,
    }
  }

  return {
    unassignedShiftForm,
    useSubmitUnassignedCustomShift,
  }
}

export default useUnassignedCustomShiftForm
